module.exports = ".container-switcher {\n  display: block; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modulo-servicios/formulario-servicio-general/formulario-servicio-general.component.scss
// module id = ./src/app/components/modulo-servicios/formulario-servicio-general/formulario-servicio-general.component.scss
// module chunks = main